import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Collapse,
  styled,
  Drawer as MuiDrawer,
  Tooltip,
  ListItemIcon,
  ListItemButton,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  FaChartBar,
  FaCogs,
  FaTree,
  FaFileInvoice,
  FaShoppingCart,
  FaUsers,
  FaAppStore,
  FaEdit,
  FaFileAlt,
} from "react-icons/fa";
import { FaBuffer } from "react-icons/fa6";
import { BiSolidDashboard } from "react-icons/bi";
import { FaFileExcel } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { FaList } from "react-icons/fa";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { MdCategory } from "react-icons/md";
import { HiCollection } from "react-icons/hi";
import { AiOutlineBranches } from "react-icons/ai";
import { CiBookmark } from "react-icons/ci";
import { TbFileTypeXml } from "react-icons/tb";

import { Send } from "@mui/icons-material";
import { AiOutlineUser } from "react-icons/ai";
import { AiTwotoneFileExcel } from "react-icons/ai";
import { MdInventory } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import ChatIcon from "@mui/icons-material/Chat";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import PropTypes from "prop-types";

const drawerWidthOpen = 250;
const drawerWidthCollapsed = 80;

const getDrawerItems = (applications) => {
  // MarketPlaceId'lere göre yetkileri kontrol et
  const hasXmlDealer = applications.some(
    (app) => app.SpecialApplicationId === 1
  );
  const hasStockTracking = applications.some(
    (app) => app.SpecialApplicationId === 2
  );
  const hasProductManagement = applications.some(
    (app) => app.SpecialApplicationId === 6
  );
  const hasInvoiceManagement = applications.some(
    (app) => app.SpecialApplicationId === 7
  );

  const getTooltipMessage = (disabled) => {
    return disabled
      ? "Mağaza sayfasından bu uygulamayı açabilir veya talep oluşturup satın alabilirsiniz"
      : "";
  };

  const baseDrawerItems = [
    {
      text: "Dashboard",
      icon: <BiSolidDashboard />,
      path: "/",
      disabled: false,
      tooltip: getTooltipMessage(false),
    },
    {
      text: "Siparişler",
      icon: <FaShoppingCart />,
      subItems: [
        {
          text: "Sipariş Listesi",
          icon: <FaList />,
          path: "/orders",
          disabled: false,
          tooltip: getTooltipMessage(false),
        },
        {
          text: "Sipariş Raporları",
          icon: <FaChartBar />,
          path: "/order-reports",
          disabled: false,
          tooltip: getTooltipMessage(false),
        },
      ],
      disabled: false,
      tooltip: getTooltipMessage(false),
    },
    // {
    //   text: "Fatura",
    //   icon: <FaFileInvoice />,
    //   path: "invoices",
    //   disabled: !hasInvoiceManagement,
    //   tooltip: getTooltipMessage(!hasInvoiceManagement),
    // },
      {
      text: "Faturalar",
      icon: <FaFileInvoice />,
      subItems: [
        {
          text: "Fatura Listesi",
          icon: <FaList />,
          path: "/invoices",
          disabled: false,
          tooltip: getTooltipMessage(false),
        },
        {
          text: "Fatura Müşterileri",
          icon: <FaUsers />,
          path: "/invoiceCustomers",
          disabled: false,
          tooltip: getTooltipMessage(false),
        },
      ],
      disabled: false,
      tooltip: getTooltipMessage(false),
    },
    {
      text: "Ürün Yönetimi",
      icon: <FaBuffer />,
      subItems: [
        {
          text: "Ürün Ekleme",
          icon: <IoMdAdd />,
          path: "add-product",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Ürün Listesi",
          icon: <FaList />,
          path: "products",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Pazaryeri Ürünleri",
          icon: <FaStore />,
          path: "PlaceProducts",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Kategori Ağacı",
          icon: <MdCategory />,
          subItems: [
            {
              text: "Kategoriler",
              icon: <MdCategory />,
              path: "/categorys",
              disabled: !hasProductManagement,
              tooltip: getTooltipMessage(!hasProductManagement),
            },
            {
              text: "Fiyat Kuralları",
              icon: <FaChartBar />,
              path: "/price-rules",
              disabled: !hasProductManagement,
              tooltip: getTooltipMessage(!hasProductManagement),
            },
          ],
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Markalar",
          icon: <CiBookmark />,
          path: "sellerbrand",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Varyant Eşleştir",
          icon: <AiOutlineBranches />,
          path: "/categoryVariant",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
      ],
      disabled: !hasProductManagement,
      tooltip: getTooltipMessage(!hasProductManagement),
    },
    {
      text: "Toplu İşlemler",
      icon: <HiCollection />,
      subItems: [
        {
          text: "Fiyat Güncelle",
          icon: <FaList />,
          path: "batch-processes",
          disabled: !hasProductManagement,
        },
         {
          text: "Başlık & Açıklama Güncelle",
          icon: <FaEdit />,
          path: "batch-text-processes",
          disabled: !hasProductManagement,
        },
        {
          text: "Ürün Gönderim",
          icon: <Send />,
          path: "sendProductBulk",
          disabled: !hasProductManagement,
        },
      ],
      disabled: !hasProductManagement,
    },
    {
      text: "Excel",
      icon: <FaFileExcel />,
      path: "excelproduct",
      disabled: !hasProductManagement,
    },
    {
      text: "Mesajlar",
      icon: <ChatIcon />,
      path: "questions",
      disabled: false,
    },
    {
      text: "Taleplerim",
      icon: <AssignmentIcon />,
      path: "user-tasks",
      disabled: false,
    },
    {
      text: "XML",
      icon: <TbFileTypeXml />,
      path: "XmlProductSource",
      disabled: !hasProductManagement,
    },
    {
      text: "XML Bayilik",
      icon: <AiTwotoneFileExcel />,
      subItems: [
        {
          text: "Kullanıcılar",
          icon: <AiOutlineUser />,
          path: "xmlDealerUsersPage",
          disabled: !hasXmlDealer,
        },
        {
          text: "XML",
          icon: <TbFileTypeXml />,
          path: "xmldealer",
          disabled: !hasXmlDealer,
        },
      ],
      disabled: !hasXmlDealer,
    },
    {
      text: "Stok Takibi",
      icon: <MdInventory />,
      path: "Stock",
      disabled: !hasStockTracking,
    },
    {
      text: "Mağaza",
      icon: <FaAppStore />,
      path: "Application",
      disabled: false,
    },
  ];

  return baseDrawerItems;
};

const DrawerStyled = styled(MuiDrawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: drawerWidthOpen,
    backgroundColor: "#f7f9fc",
    color: "#333",
    transition: "width 0.3s",
    borderRight: "1px solid #e0e0e0",
  },
}));

const MobileDrawer = styled(MuiDrawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "100%",
    backgroundColor: "#f7f9fc",
    color: "#333",
    transition: "transform 0.3s",
    borderRight: "1px solid #e0e0e0",
  },
}));

const Drawer = ({ drawerOpen, handleDrawerToggle, handleItemClick }) => {
  const [openSubMenu, setOpenSubMenu] = useState({});
  const [menuItems, setMenuItems] = useState([]);
  const token = useSelector((state) => state?.auth?.user?.accessToken.token);

  const toggleSubMenu = (text) => {
    setOpenSubMenu((prev) => ({
      ...prev,
      [text]: !prev[text],
    }));
  };

  const ListItemStyled = styled(ListItem)(({ theme }) => ({
    borderRadius: "8px",
    margin: "5px 10px",
    padding: "10px",
    "&:hover": {
      backgroundColor: "#eef2f6",
    },
    transition: "background-color 0.3s",
  }));

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const applications = decoded[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ]
          .map((roleString) => {
            try {
              return JSON.parse(roleString);
            } catch (parseError) {
              console.error("Role parsing error:", parseError);
              return null;
            }
          })
          .filter((item) => item !== null);

        const menuItems = getDrawerItems(applications);
        setMenuItems(menuItems);
      } catch (error) {
        console.error("Token çözme hatası:", error);
        setMenuItems(getDrawerItems([]));
      }
    } else {
      setMenuItems(getDrawerItems([]));
    }
  }, [token]);

  // Recursive olarak menüleri render eden fonksiyon
  const renderMenuItems = (items, level = 0) => {
    return items.map(({ text, icon, path, subItems, disabled, tooltip }) => (
      <React.Fragment key={text}>
        <Tooltip title={tooltip || ""} placement="right" arrow>
          <div>
            <ListItemButton
              onClick={() => {
                if (!disabled) {
                  if (subItems) {
                    toggleSubMenu(text);
                  } else {
                    handleItemClick(path);
                    // Close drawer on mobile/tablet when clicking a menu item
                    if (window.innerWidth < 900) {
                      // md breakpoint
                      handleDrawerToggle();
                    }
                  }
                }
              }}
              sx={{
                pl: 2 + level * 2,
                justifyContent: drawerOpen ? "flex-start" : "center",
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? "not-allowed" : "pointer",
              }}
              disabled={disabled}
            >
              <IconButton style={{ minWidth: 40, fontSize: "1.2rem" }}>
                {icon}
              </IconButton>
              {drawerOpen && <ListItemText primary={text} />}
              {subItems &&
                drawerOpen &&
                (openSubMenu[text] ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </div>
        </Tooltip>
        {subItems && (
          <Collapse in={openSubMenu[text]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {renderMenuItems(subItems, level + 1)}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    ));
  };

  return (
    <>
      {/* Desktop Drawer */}
      <DrawerStyled
        variant="persistent"
        anchor="left"
        open={true}
        sx={{
          display: { xs: "none", md: "block" },
          width: drawerOpen ? drawerWidthOpen : drawerWidthCollapsed,
          "& .MuiDrawer-paper": {
            width: drawerOpen ? drawerWidthOpen : drawerWidthCollapsed,
          },
        }}
      >
        <Box role="presentation">
          <List sx={{ marginTop: "60px" }}>{renderMenuItems(menuItems)}</List>
          <Divider />
        </Box>
      </DrawerStyled>

      {/* Mobile Drawer */}
      <MobileDrawer
        variant="temporary"
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: "100%",
            transform: drawerOpen ? "none" : "translateX(-100%)",
            transition: "transform 0.3s ease-in-out",
          },
        }}
      >
        <Box
          role="presentation"
          sx={{
            height: "100%",
            overflow: "auto",
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
            },
          }}
        >
          <List
            sx={{
              marginTop: "70px",
              padding: "0 8px",
            }}
          >
            {renderMenuItems(menuItems)}
          </List>
          <Divider />
        </Box>
      </MobileDrawer>
    </>
  );
};

Drawer.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  handleItemClick: PropTypes.func.isRequired,
};

export { Drawer };
